export default function Footer() {
    return (
        <>
        <div className="footer">
          <div className="boxing">
            <h4>About</h4>
            <p>
            It refers to the percentage of visitors to your site who complete a desired action, like making a purchase. High conversion rates are a key goal for e-commerce businesses, as they indicate that the site is effectively encouraging users to take action (like buying a product or signing up for a service).            </p>
          </div>
          <div className="boxing">
            <h4>Categories</h4>
            <ul>
              <li>Clothing</li>
              <li>Shoes</li>
              <li>Belt</li>
              <li>Hand bag</li>
              <li>Jacket</li>
            </ul>
          </div>
          <div className="boxing">
            <h4>Information</h4>
            <ul>
              <li>Clothing</li>
              <li>Shoes</li>
              <li>Belt</li>
              <li>Hand bag</li>
              <li>Jacket</li>
            </ul>
          </div>
          <div className="boxing">
            <h4>Contact</h4>
            <p>Address: Phnom Penh, Cambodia</p>
            <hr color="grey" width="230px"/>
            <p>Phone: +855 123456789</p>
            <p>Email: davidcontact911@gmail.com</p>
    
          </div>
        </div>
        <div className="footer-cover">
            <h4>Copyright 2024 All right reserved | Build by M-David</h4>
        </div>
        </>
      );
};
